const ModalEncuestaTipos = {
    data: {
        MOSTRAR_ENCUESTA: 10056789876,
        GUARDAR_NOTA_SOCIO: 82749312356,
        LOAD_POSTS_REQUEST_ENCUESTA: 98761258097,
        LOAD_POSTS_SUCCESS_ENCUESTA: 134689633445,
        LOAD_POSTS_FAILURE_ENCUESTA: 134687356334
    }
}

export default ModalEncuestaTipos;